// Settings tab — provider keys + per-workspace Connected Repos panel
// (A01 GitHub OAuth flow + repo attach).

import { TabScrollbox } from "../../chrome/TabScrollbox";
import { Link } from "react-router-dom";
import { ProviderKeysPanel } from "../../settings/ProviderKeysPanel";
import { AutonomyPanel } from "../AutonomyPanel";
import { CaptainCommsPanel } from "../CaptainCommsPanel";
import { ConnectedReposPanel } from "../ConnectedReposPanel";
import { IntegrationsPanel } from "../IntegrationsPanel";
import { ModelAccessPanel } from "../ModelAccessPanel";
import { OrgMembersPanel } from "../OrgMembersPanel";
import { BillingPanel } from "../BillingPanel";
import { ThreadsPanel } from "../ThreadsPanel";
import { WorkspaceKeysPanel } from "../WorkspaceKeysPanel";
import type { DrawerContent } from "./drawerContent";

interface Props {
  orgId: number | null;
  workspaceId: number;
  onOpenDrawerContent?: (content: DrawerContent) => void;
}

export function SettingsTab({ orgId, workspaceId, onOpenDrawerContent }: Props) {
  if (orgId == null) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
        <p className="max-w-md text-xs text-muted">
          No org is resolved for this workspace yet. Open Settings directly
          to manage provider keys.
        </p>
        <Link
          to="/settings"
          className="rounded-md border border-edge bg-surface-raised px-3 py-1.5 text-xs font-medium text-primary transition-colors hover:border-accent"
        >
          Open Settings →
        </Link>
      </div>
    );
  }
  return (
    <TabScrollbox>
      <div className="flex w-full flex-col gap-6">
        <header>
          <p className="text-xs text-muted">
            BYOK provider keys, connected GitHub repos, and per-workspace
            preferences. Team design lives on Personas, comparison lives on
            Models, and archaeology lives on the Road.
          </p>
        </header>

        <BillingPanel />

        <AutonomyPanel workspaceId={workspaceId} />

        <CaptainCommsPanel workspaceId={workspaceId} />

        <ConnectedReposPanel workspaceId={workspaceId} />

        <ModelAccessPanel workspaceId={workspaceId} />

        <WorkspaceKeysPanel workspaceId={workspaceId} />

        <IntegrationsPanel workspaceId={workspaceId} />

        <OrgMembersPanel orgId={orgId} />

        <ThreadsPanel
          workspaceId={workspaceId}
          onOpenDrawerContent={onOpenDrawerContent}
        />

        <ProviderKeysPanel orgId={orgId} />
      </div>
    </TabScrollbox>
  );
}
